import HubPage from '../../components/HubPage';
export default function LegalHub() { return <HubPage hubKey="legal" />; }
